import { defineMessages } from "react-intl";

const messages = defineMessages({
  closedStageDealAmount: {
    id: "dashboard.cards.closedStageDealAmount.chart.closedStageDealAmount",
    defaultMessage: "Deal Amount",
    description: "Deal Amount text in a tooltip in Chart in the Deal Amount card",
  },
  goalLabel: {
    id: "dashboard.cards.closedStageDealAmount.goalLabel",
    defaultMessage: "Deal Amount",
    description: "Goal label in the Deal Amount card",
  },
  organization: {
    id: "dashboard.cards.closedStageDealAmount.subtitle.organization",
    defaultMessage: "Organization",
    description:
      "Organization title for the case when ranking a team for Subtitle of the Deal Amount card",
  },
  subtitle: {
    id: "dashboard.cards.closedStageDealAmount.subtitle",
    defaultMessage:
      "{entireOrg, select, true {All Users} other {{name}}}{showRank, select, true { • {rank, selectordinal, one {#st} two {#nd} few {#rd} other {#th}} in {teamName}} other {}}",
    description: "Subtitle of the Deal Amount card",
  },
  tooltipLabelForWeek: {
    id: "dashboard.cards.closedStageDealAmount.chart.tooltip.label.week",
    defaultMessage: "eeee, PPP",
    description: "Tooltip label in Chart in the Deal Amount card for week date ranges",
  },
  unknown: {
    id: "dashboard.cards.closedStageDealAmount.subtitle.unknown",
    defaultMessage: "Unknown",
    description:
      "Unknown title for the case when ranking a team for Subtitle of the Deal Amount card",
  },
  xAxisLabel: {
    id: "dashboard.cards.closedStageDealAmount.chart.xAxis.label.default",
    defaultMessage: "MM/dd",
    description: "X-axis label in Chart in the Deal Amount card",
  },
  xAxisLabelForWeek: {
    id: "dashboard.cards.closedStageDealAmount.chart.xAxis.label.week",
    defaultMessage: "eeeeee, MM/dd",
    description: "X-axis label in Chart in the Deal Amount card for week date ranges",
  },
});

export default messages;
